export default "__VITE_ASSET__BRQ0Cyzj__"